import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { Tabs, TabsList, TabsTrigger } from '@/components/Tabs';
import { Text } from '@/components/typography';
import { numberFormat } from '@/helper/numberFormatter';

import type { ProviderCategoryCounts, ProviderCategoryType } from './types';

type Props = {
  providerCategory: ProviderCategoryType;
  providerCategoryCounts: ProviderCategoryCounts;
  onProviderCategoryChange: (category: ProviderCategoryType) => void;
};

const IntegrationMenu = ({
  providerCategory,
  providerCategoryCounts,
  onProviderCategoryChange,
}: Props) => {
  const categories: {
    key: ProviderCategoryType;
    label: string;
    count: string | undefined;
  }[] = [
    {
      key: 'all',
      label: t`All`,
      count: providerCategoryCounts.all ? numberFormat(providerCategoryCounts.all) : undefined,
    },
    {
      key: 'connected',
      label: t`Connected`,
      count: providerCategoryCounts.connected
        ? numberFormat(providerCategoryCounts.connected)
        : undefined,
    },
    {
      key: 'notConnected',
      label: t`Not Connected`,
      count: providerCategoryCounts.notConnected
        ? numberFormat(providerCategoryCounts.notConnected)
        : undefined,
    },
    {
      key: 'error',
      label: t`Error`,
      count: providerCategoryCounts.error ? numberFormat(providerCategoryCounts.error) : undefined,
    },
    {
      key: 'crm',
      label: t`CRM`,
      count: providerCategoryCounts.crm ? numberFormat(providerCategoryCounts.crm) : undefined,
    },
    {
      key: 'advertising',
      label: t`Ads`,
      count: providerCategoryCounts.advertising
        ? numberFormat(providerCategoryCounts.advertising)
        : undefined,
    },
    {
      key: 'ai',
      label: t`AI`,
      count: providerCategoryCounts.ai ? numberFormat(providerCategoryCounts.ai) : undefined,
    },
  ];

  return (
    <div className="flex flex-col gap-2">
      <Text variant="label">
        <Trans>Browse Categories</Trans>
      </Text>
      <Tabs
        orientation="vertical"
        value={providerCategory}
        onValueChange={(value) => onProviderCategoryChange(value as ProviderCategoryType)}
      >
        <TabsList className="w-full items-stretch rounded-none bg-transparent max-xl:flex-row max-xl:flex-wrap">
          {categories.map((category) => (
            <TabsTrigger key={category.key} value={category.key} className="flex w-full py-1.5">
              <div className="flex-1 text-start">{category.label}</div>
              {category.count && <span className="text-gray-500">{category.count}</span>}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default IntegrationMenu;
